import React, { useState } from 'react';

export default function PollQuestion({ question, answered, onSubmit }) {
  const [text, setText] = useState('');
  const { payload, revealed } = question;
  const isLocked = answered || Boolean(revealed);

  const submit = (e) => {
    e.preventDefault();
    const trimmed = text.trim();
    if (!trimmed || isLocked) return;
    onSubmit({ text: trimmed });
  };

  return (
    <div className="card stack">
      <div className="row-between">
        <span className="q-kicker">คำถามปลายเปิด</span>
      </div>
      <h2>{payload.question}</h2>

      {isLocked ? (
        <p className="text-dim text-center">
          {answered ? 'ส่งคำตอบเรียบร้อยแล้ว ขอบคุณสำหรับความคิดเห็น' : 'เฉลยคำตอบแล้ว — ปิดรับคำตอบข้อนี้'}
        </p>
      ) : (
        <form className="stack" onSubmit={submit}>
          <div className="field">
            <textarea
              rows={3}
              maxLength={140}
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder={payload.placeholder || 'พิมพ์คำตอบของคุณ...'}
              autoFocus
            />
          </div>
          <button className="btn btn-primary btn-block" type="submit" disabled={!text.trim() || isLocked}>
            ส่งคำตอบ
          </button>
        </form>
      )}
    </div>
  );
}
